$(document).on('ready', function () {
    $.fn.collapseElement = function () {
        var $self = $(this);
        var $element = $self.find('.js-collapse-element');
        var $button = $self.find('.js-collapse-button');
        var $buttonFixed = $('.js-fixed-button');


        var init = function () {
            $button.each(function (index) {
                $(this).on('click', function () {
                    toggleClass(index);
                });
            });
        };

        var toggleClass = function (index) {
            var $item = $element.eq(index);
            var positionElement = findPosition($item).top;
            if($item.hasClass('active')) {
                removeClass();
                return;
            }
            removeClass();
            addClass();
            $buttonFixed.removeClass('active');
            $item.css('top', positionElement);
            $item.addClass('active');
            $item.removeClass('covert');
        };

        var removeClass = function () {
            $element.each(function () {
                $(this).removeClass('active');
                $(this).removeClass('covert');
            });
        };

        var addClass = function () {
            $element.each(function () {
                $(this).addClass('covert');
            });
        };

        var findPosition = function (element) {
            return element.position();
        };

        init();
    };

    $('.js-collapse-wrapper').each(function () {
        $(this).data('collapseElement', $(this).collapseElement());
    });

});
